export enum StateEnum {
  TODO = 1,
  INPROGRESS = 2,
  DONE = 3,
}
